'use strict';

/* Expose. */
module.exports = toString;

/* Get the text content of a node.  If the node itself
 * does not expose plain-text fields, `toString` will
 * recursivly try its children. */
function toString(node) {
  return valueOf(node) ||
    (node.children && node.children.map(toString).join('')) ||
    '';
}

/* Get the value of `node`.  Checks, `value`,
 * `alt`, and `title`, in that order. */
function valueOf(node) {
  if (!node) {
    return '';
  }
  return node.value ? node.value : (node.alt ? node.alt : node.title) || '';
}



//////////////////
// WEBPACK FOOTER
// ./~/mdast-util-to-string/index.js
// module id = 36
// module chunks = 94053359063892 107818501498521